// What "Raport nou" hands Acasă after a save (spec 054 T044, research R8).
//
// The page navigates to `/:role/home` with this object as the router state, and
// the home band reads it back to say "Raport salvat" with the report it names.
// `rowCount` is the draft's own count, never the confirm's `acceptedRows`: an
// idempotent replay of the confirm answers 0 there (draft.service.ts).
export interface SavedReportState {
  submissionId: string;
  reportNumber: string;
  rowCount: number;
  siteName: string;
  /** When the server received the save; the band's "la ora hh:mm". */
  savedAtIso?: string;
}

/**
 * The router state, if it is a save. History state outlives the page that
 * wrote it (a reload keeps it, another tab can hold anything), so it is read as
 * untrusted input rather than cast.
 */
export function readSavedReport(state: unknown): SavedReportState | null {
  if (typeof state !== 'object' || state === null) return null;
  const candidate = state as Record<string, unknown>;
  const { submissionId, reportNumber, rowCount, siteName, savedAtIso } = candidate;
  if (typeof submissionId !== 'string' || submissionId === '') return null;
  if (typeof reportNumber !== 'string' || typeof siteName !== 'string') return null;
  if (typeof rowCount !== 'number' || !Number.isInteger(rowCount) || rowCount < 0) return null;
  return {
    submissionId,
    reportNumber,
    rowCount,
    siteName,
    ...(typeof savedAtIso === 'string' ? { savedAtIso } : {}),
  };
}
